module.exports = __webpack_public_path__ + "img/model_53_zh.4cebec02.jpg";